<template>
  <SettingsModal
    v-bind="{ isVisible }"
    :headline="$t(`licensedterritory.${licensedTerritory}`)"
    icon="location"
    :tracking="{
      action: 'state_switch',
      topicKey: 'state_selection',
      customMessage: trackingOptions,
      customTopic: $t(`licensedterritory.${licensedTerritory}`),
    }"
    @close="isVisible = false"
  >
    <ListSelect
      v-model="formattedOptions"
      class="px-100"
      @option-click="(option) => (option.selected ? (isVisible = false) : null)"
    />
    <template #footer>
      <div class="flex items-center">
        <LanguageSwitch @option-click="isVisible = false" />
      </div>
    </template>
  </SettingsModal>
</template>

<script lang="ts" setup>
const { licensedTerritory, options } = useStateSwitch()

const isVisible = defineModel('isVisible', { default: false, type: Boolean })

const formattedOptions = computed(() =>
  options.value.map((option) => ({
    href: option.href,
    hrefTitle: option.title,
    label: option.state,
    selected: option.selected,
    value: option.id,
  })),
)
const trackingOptions = computed(() =>
  options.value.map(({ state }) => state).join(', '),
)
</script>

<style lang="scss">
.state-switch {
  &__card {
    overflow: hidden;
    background-color: token('color/background/secondary/secondary/bold');

    &--body {
      height: 100%;
      padding: 0;
    }

    @include media-tablet {
      height: 100%;
      border-radius: 0;
    }
  }

  &__modal {
    &--background {
      padding: 4rem;

      @include media-tablet {
        padding: 0;
        background: none;
        backdrop-filter: none;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.state-switch {
  &__header {
    position: sticky;
    top: 0;
  }
}

.footer {
  flex-wrap: wrap;
  row-gap: token('size/space/gap/100');
  border-top: token('size/border/100') solid token('color/blue/300');
}
</style>
